<app-audit-logs-table
  [initialQuery]="initialQuery()"
  [tableColumnsDef]="auditTableDef()"
></app-audit-logs-table>
